import { render, staticRenderFns } from "./our-story.vue?vue&type=template&id=9a0b13d8&"
import script from "./our-story.vue?vue&type=script&lang=js&"
export * from "./our-story.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports